import { render, staticRenderFns } from "./RunningConferences.vue?vue&type=template&id=3e4ad399&"
import script from "./RunningConferences.vue?vue&type=script&lang=ts&"
export * from "./RunningConferences.vue?vue&type=script&lang=ts&"
import style0 from "./RunningConferences.vue?vue&type=style&index=0&id=3e4ad399&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports